import {css} from 'lit'; export default css`*,:after,:before{box-sizing:border-box}.sds-grid-container{display:contents}`;
    